export default "__VITE_ASSET__BqJq5UAR__"